import { Headhunter, HeadhunterDetails } from '@/interface/Headhunter';
import BookmarkedAttrs from '@/interface/BookmarkedAttrs';
import { getFakeHeadhunter } from '@/helpers/registration-lp';

const state = () => ({
  isLoading: false,
  info: null,
  lastHeadhunterCid: localStorage.getItem('lastHeadhunterCid')  ,
  fetchRequest: null,
});

const mutations = {
  setLoading(currentState, newValue: boolean) {
    currentState.isLoading = newValue;
  },
  setInfo(currentState, newValue: unknown) {
    currentState.info = newValue;
  },
  saveLastSelectedHeadhunter(currentState, newValue: number) {
    currentState.lastHeadhunterCid = newValue;
  },

  setFetchRequest(currentState, newValue) {
    currentState.fetchRequest = newValue;
  },

  clearState(currentState) {
    Object.assign(currentState, {
      isLoading: false,
      info: null,
    });
  },

  setItemBookmarkStatus(currentState, item: BookmarkedAttrs) {
    if (item.id === currentState.info?.id) {
      currentState.info = {
        ...currentState.info,
        bookmarked: item.value,
      };
    }
  },
};

const actions = {
  fetch({ dispatch }, item: Headhunter) {
    return dispatch('fetchRequest', {
      item,
      type: 'details',
    });
  },
  fetchPreview({ dispatch }, item: HeadhunterDetails) {
    return dispatch('fetchRequest', {
      item,
      type: 'preview',
    });
  },
  fetchRequest({ commit, rootGetters }, { item, type }: { item: Headhunter; type: string }) {
    const { id, match } = item;
    commit('setLoading', true);

    const query =
      type === 'preview' ? `?country=${rootGetters['country/currentCountry'].value}` : '';
    const url =
      this.getters.getApiLink('headhunter.details_v2',
        {
          companyUniqueId: id,
          match: match || 0,
        },
      ) + query;

    const request = this.$api
      .get(url)
      .then(({ data }) => {
        // data = {"id":574078,"md5":"1f256a5400b2a102b6a2962a6bea8815","activityLevel":1,"totalNumberOfJobs":0,"showPremiumDetails":false,"name":"Headhunter:in 5938978","email":"dolor sit amet","website":"nulla in","logo":"\/resources\/company\/default_logos\/officeBlurred.png","topData":{"channels":{"1":"Management \u0026 Operations"},"locations":{"1":"Saarbr\u00fccken"}},"phone":"dolor sit amet","city":"lacus sed egestas","street":"non egestas","numberOfJobsPerPeriodText":"Im Durchschnitt 0 neue Stellen pro Quartal","jobs":0,"match":100};
        const info: HeadhunterDetails = data || null;
        commit('setInfo', info);
        return info;
      })
      .finally(() => {
        commit('setLoading', false);
      });

    commit('setFetchRequest', request);

    return request;
  },
  fetchFake({ commit, rootGetters }, id) {
    commit('setLoading', true);
    setTimeout(() => {
      const info = getFakeHeadhunter(id);

      commit('setInfo', info);
      commit('setFetchRequest', info);
      commit('setLoading', false);
    }, 500)
  },
  destroy({ state: currentState, commit }) {
    const { fetchRequest } = currentState;

    if (fetchRequest) {
      const { abort } = fetchRequest || {};
      if (typeof abort === 'function') {
        abort();
      }

      if (!abort && fetchRequest.finally) {
        fetchRequest.finally(() => {
          commit('clearState');
        });
      }
    }

    commit('clearState');
  },

  setItemBookmarkStatus({ commit }, newValue: boolean) {
    commit('setItemBookmarkStatus', newValue);
    return newValue;
  },
};
// actions end

const getters = {
  isLoading: (s) => s.isLoading,
  info: (s) => s.info,
  selectedHedhunter: (s) => s.lastHeadhunterCid,
};

export default {
  namespaced: true,

  mutations,
  state,
  actions,
  getters,
};
